import { createComponent } from '@carvana/merch-components';
import React from 'react';

const UnselectableText = createComponent('span', {
  className: 'pointer-events-none select-none'
});

type OwnProps = {
  filler?: string;
  size: number;
  tag?: React.ComponentType<any>;
};

const Spacer = ({
  filler = '&nbsp;',
  size,
  tag: Tag = UnselectableText
}: OwnProps) => {
  const html = new Array(size).fill(filler).join('');

  return <Tag dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Spacer;
